<template>
  <div>
    <apexchart
      v-if="isLoaded"
      type="rangeBar"
      :height="chartHeight"
      :options="chartOptions"
      :series="seriesApex"
    />
    <slot name="loading" v-else>
      <v-progress-linear
        indeterminate
        color="warning"
        top
      />
    </slot>
  </div>
</template>

<script>
import ru from 'apexcharts/dist/locales/ru.json'
import moment from 'moment'
import { mapActions } from 'vuex'
import { axios } from '~/plugins/axios'

export default {
  name: 'TimelineChartsQueue',
  props: {
    data: {
      type: Object,
      default() {
        return {
          user: 4385,
          period: ['2022-12-05 00:00:00', '2022-12-05 23:59:59'],
        }
      }
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: 'rangeBar',
          background: '#00000000',
          events: {
            dataPointSelection: this.eventHandler,
          },
          locales: [ru],
          defaultLocale: 'ru',
          
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '80%'
          }
        },
        xaxis: {
          type: 'datetime'
        },
        stroke: {
          show: false,
        },
        fill: {
          type: 'solid',
          opacity: 1
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left'
        },

        theme: {
            mode: 'light', 
        },

        tooltip: {
          custom({y1, y2, ctx, dataPointIndex}) {
            let date = moment.utc(y1).format('DD/MM');
            let n1 = moment.utc(y1).format('HH:mm:ss');
            let n2 = moment.utc(y2).format('HH:mm:ss');
            let category = ctx.data.twoDSeriesX[dataPointIndex];
            let duration = moment.utc(y2).subtract(moment.utc(y1)).format('HH:mm:ss');

            return `<div class="apexcharts-tooltip-rangebar">
                      <span>
                        ${category} <br>
                        Дата: ${date} <br>
                        ${n1} - ${n2} <br>
                        Длительность: ${duration} <br>
                      </span>
                    </div>`;
          },
        },
      },

      chartHeight: 450,
      
      seriesApex: null,

      isLoaded: false,

      tmp: null,
    }
  },

  computed: {
    isDarkTheme() {
      return this.$vuetify.theme.isDark;
    },
  },

  watch: {
    isDarkTheme(curr) {
      // fucking apex :(
      let mode = curr ? 'dark' : 'light';
      this.chartOptions = {
        chart: {
          background: '#00000000'
        },
        theme: {mode}
      };
    },
  },

  methods: {
    ...mapActions({
      loadTimeline: 'timeline/loadTimeline',
      clearTimeline: 'timeline/clearTimeline',
      setSuccess: 'shared/setSuccess',
      setError: 'shared/setError'
    }),
    
    getApexSeries(operator) {
      let res =  [{
        data: [],
      }]

      // let colors = {
      //   increase: '#28A745',
      //   decrease: '#2196F3',
      //   ignore: '#555555',
      //   result: '#9820f3',
      // }

      operator.map(item => {
        if (!item.end) item.end = moment().format('YYYY-MM-DD HH:mm:ss');
        add(item, item.name, item.color);
      })

      let h = countRow(res) * 30;

      if (h >= 450 ) this.chartHeight = h;

      // this.tmp = res[0].data

      return res;


      function add(period, x, fillColor) {
        let seriesData = {
          x,
          y: [
            new Date(period.start).getTime() + 10800000,
            new Date(period.end).getTime() + 10800000,
          ]
        }
        if (fillColor) {
          seriesData.fillColor = fillColor;
        }
        
        res[0].data.push(seriesData)
      }

      function countRow(series) {
        let queues = series[0].data.flatMap(el => el.x);
        let clearQueues = [...new Set(queues)];
        return clearQueues.length
      }
    },

    eventHandler(ev, {data}, point) {
      if (!point) return
      let index = point.dataPointIndex;
      let cat = data.twoDSeriesX[index]
      let n1 = data.w.globals.initialSeries[0].data[index].y[0]
      let n2 = data.twoDSeries[index]
      let date = moment.utc(n1).format('DD/MM')

      let d1 = moment.utc(n1).format('HH:mm:ss')
      let d2 = moment.utc(n2).format('HH:mm:ss')
      let duration = moment.utc(n2).subtract(moment.utc(n1)).format('HH:mm:ss');

      let str = `${cat}\nДата: ${date}\n${d1} - ${d2}\n`
      str += `Длительность: ${duration}`
      window.navigator.clipboard.writeText(str).then(() => {
        this.setSuccess({message: 'Скопировано в буфер'});
      }, (err) => {
        this.setError({message: err});
      })
    },
  },

  async mounted() {
    // тема чартов по человечески не работает (((
    if (this.isDarkTheme) {
      let options = this.chartOptions;
      options.theme.mode = 'dark';
      this.chartOptions = Object.assign(this.chartOptions, options);
    }
    
    let operator = await axios.post(`/api/users/${this.data.user}/sessions`, this.data).then(resp => resp.data);

    this.seriesApex = this.getApexSeries(operator);

    this.isLoaded = true;
  },

  beforeDestroy() {
  },
}
</script>

<style>

</style>